import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { EventManager } from 'app/shared/services';

import { LoginService } from 'app/core/login/login.service';
import { StateStorageService } from 'app/core/auth/state-storage.service';

@Component({
    selector: 'app-login-modal',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']})
export class LoginModalComponent implements AfterViewInit {
    @Input() sessionExpired = false;

    @ViewChild('usernameInput') usernameInput: ElementRef;

    authenticationError: boolean;
    password: string;
    rememberMe = true;
    username: string;
    credentials: any;
    passwordShown = false;
    signingIn = false;

    constructor(
        private eventManager: EventManager,
        private loginService: LoginService,
        private stateStorageService: StateStorageService,
        private elementRef: ElementRef,
        private router: Router,
        public activeModal: NgbActiveModal
    ) {
        this.credentials = {};
    }

    cancel() {
        this.credentials = {
            username: null,
            password: null,
            rememberMe: true
        };
        this.authenticationError = false;
        this.activeModal?.dismiss('cancel');
    }

    ngAfterViewInit() {
        this.usernameInput?.nativeElement?.focus();
    }

    login() {
        this.signingIn = true;
        this.loginService
            .login({
                username: this.username,
                password: this.password,
                rememberMe: this.rememberMe
            })
            .then(() => {
                this.signingIn = false;
                this.authenticationError = false;
                this.activeModal?.dismiss('login success');
                if (this.router.url === '/register' || /^\/activate\//.test(this.router.url) || /^\/reset\//.test(this.router.url)) {
                    this.router.navigate(['']);
                }

                this.eventManager.broadcast({
                    name: 'authenticationSuccess',
                    content: 'Sending Authentication Success'
                });

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                const redirect = this.stateStorageService.getUrl() as string;
                if (redirect) {
                    this.stateStorageService.storeUrl(null);
                    this.router.navigateByUrl(redirect);
                }
            })
            .catch(() => {
                this.signingIn = false;
                this.authenticationError = true;
            });
    }

    register() {
        this.activeModal?.dismiss('to state register');
        this.router.navigate(['/register']);
    }

    requestResetPassword() {
        this.activeModal?.dismiss('to state requestReset');
        this.router.navigate(['/reset', 'request']);
    }
}
